module.exports = __webpack_public_path__ + "static/real-time-data-updates-65566292a9734c942ef11b3dace4489b.png";